// Revenue Breakdown Data
// ACTUALIZADO: Receita 2025 = 250M USD (1T: 100M, 2T: 50M, 3T: 75M, 4T: 25M)
export const revenueBreakdownData = {
  2024: {
    byType: [
      { type: "Regular", value: 185, percentage: 75.5 },
      { type: "Special", value: 48, percentage: 19.6 },
      { type: "Rejected/Low Grade", value: 12, percentage: 4.9 },
    ],
    monthlyByType: [
      { month: "Jan", regular: 14.0, special: 3.5, rejected: 1.0 },
      { month: "Fev", regular: 14.5, special: 3.7, rejected: 1.0 },
      { month: "Mar", regular: 16.5, special: 4.2, rejected: 1.1 },
      { month: "Abr", regular: 15.2, special: 3.9, rejected: 1.0 },
      { month: "Mai", regular: 14.9, special: 3.9, rejected: 1.0 },
      { month: "Jun", regular: 16.9, special: 4.4, rejected: 1.1 },
      { month: "Jul", regular: 16.0, special: 4.2, rejected: 1.0 },
      { month: "Ago", regular: 15.5, special: 4.0, rejected: 1.0 },
      { month: "Set", regular: 14.9, special: 3.9, rejected: 1.0 },
      { month: "Out", regular: 15.9, special: 4.2, rejected: 1.0 },
      { month: "Nov", regular: 15.3, special: 3.9, rejected: 1.0 },
      { month: "Dez", regular: 15.4, special: 4.0, rejected: 1.0 },
    ],
    quantityByType: [
      { type: "Regular", carats: 820000 },
      { type: "Special", carats: 95000 },
      { type: "Rejected", carats: 185000 },
    ],
    avgPriceByType: {
      regular: 215,
      special: 453,
      rejected: 70,
    },
    byGeography: [
      { region: "Belgium/Antwerp", value: 112, percentage: 45.7 },
      { region: "UAE/Dubai", value: 54, percentage: 22.0 },
      { region: "Israel", value: 42, percentage: 17.1 },
      { region: "India", value: 25, percentage: 10.2 },
      { region: "Others", value: 12, percentage: 5.0 },
    ],
  },
  2025: {
    // TOTAL: 250M USD (1T: 100M, 2T: 50M, 3T: 75M, 4T: 25M)
    byType: [
      { type: "Regular", value: 183, percentage: 73.2 },
      { type: "Special", value: 54.5, percentage: 21.8 },
      { type: "Rejected/Low Grade", value: 12.5, percentage: 5.0 },
    ],
    // Distribuição mensal ajustada aos trimestres: 1T=100M, 2T=50M, 3T=75M, 4T=25M
    monthlyByType: [
      // 1T25: 100M total (Jan: 30M, Fev: 32M, Mar: 38M)
      { month: "Jan", regular: 22.0, special: 6.5, rejected: 1.5 },
      { month: "Fev", regular: 23.4, special: 7.0, rejected: 1.6 },
      { month: "Mar", regular: 27.8, special: 8.3, rejected: 1.9 },
      // 2T25: 50M total (Abr: 16M, Mai: 16M, Jun: 18M)
      { month: "Abr", regular: 11.7, special: 3.5, rejected: 0.8 },
      { month: "Mai", regular: 11.7, special: 3.5, rejected: 0.8 },
      { month: "Jun", regular: 13.2, special: 3.9, rejected: 0.9 },
      // 3T25: 75M total (Jul: 24M, Ago: 25M, Set: 26M)
      { month: "Jul", regular: 17.6, special: 5.2, rejected: 1.2 },
      { month: "Ago", regular: 18.3, special: 5.5, rejected: 1.2 },
      { month: "Set", regular: 19.0, special: 5.7, rejected: 1.3 },
      // 4T25: 25M total (Out: 9M, Nov: 8.5M, Dez: 7.5M)
      { month: "Out", regular: 6.6, special: 2.0, rejected: 0.4 },
      { month: "Nov", regular: 6.2, special: 1.9, rejected: 0.4 },
      { month: "Dez", regular: 5.5, special: 1.6, rejected: 0.4 },
    ],
    quantityByType: [
      { type: "Regular", carats: 740000 },
      { type: "Special", carats: 100000 },
      { type: "Rejected", carats: 160000 },
    ],
    avgPriceByType: {
      regular: 247,
      special: 545,
      rejected: 78,
    },
    byGeography: [
      { region: "Belgium/Antwerp", value: 110, percentage: 44.0 },
      { region: "UAE/Dubai", value: 59.5, percentage: 23.8 },
      { region: "Israel", value: 40.25, percentage: 16.1 },
      { region: "India", value: 27.75, percentage: 11.1 },
      { region: "Others", value: 12.5, percentage: 5.0 },
    ],
    // Dados trimestrais explícitos
    byQuarter: [
      { quarter: "1T25", value: 100, percentage: 40.0 },
      { quarter: "2T25", value: 50, percentage: 20.0 },
      { quarter: "3T25", value: 75, percentage: 30.0 },
      { quarter: "4T25", value: 25, percentage: 10.0 },
    ],
  },
  2026: {
    byType: [
      { type: "Regular", value: 225, percentage: 72.1 },
      { type: "Special", value: 72, percentage: 23.1 },
      { type: "Rejected/Low Grade", value: 15, percentage: 4.8 },
    ],
    monthlyByType: [
      { month: "Jan", regular: 18.2, special: 5.7, rejected: 1.3 },
      { month: "Fev", regular: 18.9, special: 5.9, rejected: 1.3 },
      { month: "Mar", regular: 20.6, special: 6.4, rejected: 1.5 },
      { month: "Abr", regular: 19.7, special: 6.1, rejected: 1.4 },
      { month: "Mai", regular: 19.2, special: 5.9, rejected: 1.4 },
      { month: "Jun", regular: 21.5, special: 6.7, rejected: 1.6 },
      { month: "Jul", regular: 20.1, special: 6.2, rejected: 1.5 },
      { month: "Ago", regular: 19.4, special: 6.0, rejected: 1.4 },
      { month: "Set", regular: 19.0, special: 5.8, rejected: 1.4 },
      { month: "Out", regular: 19.9, special: 6.2, rejected: 1.4 },
      { month: "Nov", regular: 19.1, special: 5.9, rejected: 1.4 },
      { month: "Dez", regular: 10.1, special: 3.2, rejected: 0.7 },
    ],
    quantityByType: [
      { type: "Regular", carats: 950000 },
      { type: "Special", carats: 140000 },
      { type: "Rejected", carats: 180000 },
    ],
    avgPriceByType: {
      regular: 237,
      special: 514,
      rejected: 83,
    },
    byGeography: [
      { region: "Belgium/Antwerp", value: 137, percentage: 43.9 },
      { region: "UAE/Dubai", value: 78, percentage: 25.0 },
      { region: "Israel", value: 47, percentage: 15.1 },
      { region: "India", value: 35, percentage: 11.2 },
      { region: "Others", value: 15, percentage: 4.8 },
    ],
  },
};

// Customer Concentration Data
// ACTUALIZADO: Valores 2025 recalculados para 250M USD total
export const customerConcentrationData = {
  2024: [
    { customer: "Client A", percentage: 18.5, value: 45.3 },
    { customer: "Client B", percentage: 14.2, value: 34.8 },
    { customer: "Client C", percentage: 11.8, value: 28.9 },
    { customer: "Client D", percentage: 9.5, value: 23.3 },
    { customer: "Client E", percentage: 8.2, value: 20.1 },
    { customer: "Top 5", percentage: 62.2, value: 152.4, isSubtotal: true },
    { customer: "Others", percentage: 37.8, value: 92.6 },
  ],
  2025: [
    { customer: "Client A", percentage: 17.8, value: 44.5 },
    { customer: "Client B", percentage: 15.1, value: 37.75 },
    { customer: "Client C", percentage: 12.4, value: 31.0 },
    { customer: "Client D", percentage: 10.2, value: 25.5 },
    { customer: "Client E", percentage: 8.7, value: 21.75 },
    { customer: "Top 5", percentage: 64.2, value: 160.5, isSubtotal: true },
    { customer: "Others", percentage: 35.8, value: 89.5 },
  ],
  2026: [
    { customer: "Client A", percentage: 16.5, value: 51.5 },
    { customer: "Client B", percentage: 14.8, value: 46.2 },
    { customer: "Client C", percentage: 13.1, value: 40.9 },
    { customer: "Client D", percentage: 11.2, value: 35.0 },
    { customer: "Client E", percentage: 9.4, value: 29.3 },
    { customer: "Top 5", percentage: 65.0, value: 202.9, isSubtotal: true },
    { customer: "Others", percentage: 35.0, value: 109.1 },
  ],
};
